import { BaseQueryFn, EndpointBuilder, FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { Document } from 'services/documents/types/dtos';
import { Product, ResponseProductDto } from '../types/dtos';
import { APP_ENDPOINTS } from 'app/endpoints';

type LogoType = 'original' | 'medium' | 'thumbnail' | 'small';

const extractLogo = (logo: Document, type: LogoType) => JSON.parse(logo.filePaths)[type];

export default (builder: EndpointBuilder<BaseQueryFn, string, string>) =>
    builder.query<Product, string>({
        async queryFn(productId, _queryApi, _extraOptions, fetchWithBQ) {
            const productResult = await fetchWithBQ(`${APP_ENDPOINTS.PRODUCT}/${productId}`);

            if (productResult.error) return { error: productResult.error as FetchBaseQueryError };

            const product = productResult.data as ResponseProductDto;

            if (product.documentId) {
                const documentResult = await fetchWithBQ(`${APP_ENDPOINTS.DOCUMENT}/${product.documentId}`);
                if (documentResult.error) return { error: documentResult.error as FetchBaseQueryError };
                const document = documentResult.data as Document;
                return {
                    data: { ...product, logo: extractLogo(document, 'small') },
                };
            }
            return {
                data: product,
            };
        },
        providesTags: [{ type: 'product', id: 'GET-ID' }],
    });
